<template>
  <div class="text-block block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-text-icon white--text text-lg-2" />
            </div>

            <h4>
              Text Block 
              <v-icon 
                v-if = "errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <div class="block-card-body" v-if="validData">
          <form-validation 
            :append = "buttonsList.errorsCount" 
            v-model = "errorsCount">
            <vTextareaAutocomplete 
              v-model="data.text"
              :type="'textarea'"
              :counter = "1000"
              :validation-rules="autocompleteValidationRules"/>
          </form-validation>
          <buttons-list 
            :buttons="data.buttons" 
            :blocks-list="blocksList" 
            v-model = "buttonsList"/>
        </div>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import vTextareaAutocomplete from '../../../common/v-textarea-autocomplete'
import FormValidation from '../FormValidation'
import buttonsList from './common-inner-blocks/button-list'
import VueTribute from 'vue-tribute'
import Tribute from 'tributejs'

export default {
  name: 'TextBlock',
  components: {
    buttonsList,
    VueTribute,
    FormValidation
    // vTextareaAutocomplete
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    slug: {
      type: String,
      required: true
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      valid: true,
      lazyRendering: true,
      errorsCount: { errorsCount: 0 },
      buttonsList: { errorsCount: 0 },
      panel: 1,
      autocompleteValidationRules: [v => !!v || 'Text is Required']
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
    if (!this.data.buttons) {
      this.data.buttons = []
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>
